"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "portacomaro": {
    "ed88d373": [{
      "hkey": "c6293a46",
      "slug": "portacomaro",
      "name": "Portacomaro",
      "primary": true,
      "skipSearch": false
    }],
    "san-fantino": [{
      "hkey": "c6293a46",
      "slug": "portacomaro",
      "name": "Portacomaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "adb0e449": [{
      "hkey": "c6293a46",
      "slug": "portacomaro",
      "name": "Portacomaro",
      "primary": true,
      "skipSearch": false
    }],
    "spadaro": [{
      "hkey": "c6293a46",
      "slug": "portacomaro",
      "name": "Portacomaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a269160c": [{
      "hkey": "e96f6c74",
      "slug": "berruti",
      "name": "Berruti",
      "primary": true,
      "skipSearch": false
    }],
    "val-berruti": [{
      "hkey": "e96f6c74",
      "slug": "berruti",
      "name": "Berruti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;